import axios from 'axios'
import store from '@/store/index'

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    timeout: 3000
})

service.interceptors.request.use(config => {
    config.headers['Authorization'] = store.state.token
    return config
})

export default service